import React, { useEffect, useState } from "react";
import capacityplanningbanner from "../../../main/assets/images/Images/Capacity Planning - Images/capacity-planning-banner.png";
import Mobilebanner from "../../../main/assets/images/Images/Capacity Planning - Images/capacity_planning_banner.png";
import agileOperations from "../../../main/assets/images/Icons/Capacity Planning - Icons/agile-operations.png";
import agileOperations2 from "../../../main/assets/images/Icons/Capacity Planning - Icons/agile-operations2.svg";
import costSavings from "../../../main/assets/images/Icons/Capacity Planning - Icons/cost-savings.svg";
import costsavings2 from "../../../main/assets/images/Icons/Capacity Planning - Icons/cost-savings2.svg";
import maximizedresources from "../../../main/assets/images/Icons/Capacity Planning - Icons/maximized-resource-utilization.svg";
import Layer1 from "../../../main/assets/images/Icons/Capacity Planning - Icons/Layer_1.svg";
import { Col } from "react-bootstrap";
import GraphDataOnLeft from "../../../main/components/componentsHelper/platformspage/GraphDataOnLeft";
import GraphDataOnRight from "../../../main/components/componentsHelper/platformspage/GraphDataOnRight";
import PlatformLearnMore from "main/components/componentsHelper/platformspage/PlatformLearnMore";
import { SectionCard } from "main/components";
import HeadingParagrap from "main/components/componentsHelper/platformspage/HeadingParagrap";
import { Button } from "main/components/ui-components/Button";
import cpgraph from "../../../main/assets/images/Images/Capacity Planning - Images/cp_graph_01.png";
import { Link } from "react-router-dom";
import PlatformModulesBanner from "main/components/componentsHelper/platformspage/PlatformModulesBanner";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import SectionCardMobile from "main/components/componentsHelper/whtyantrapage/SectionCardMobile";
import cp_graph1 from "../../../main/assets/images/Images/Capacity Planning - Images/cp_graph1.png";
import cp_graph2 from "../../../main/assets/images/Images/Capacity Planning - Images/cp_graph2.png";
import cp_graph3 from "../../../main/assets/images/Images/Capacity Planning - Images/cp_graph3.png";
import cp_graph01 from "../../../main/assets/images/Images/Capacity Planning - Images/cp_graph_01.png";
import cp_graph02 from "../../../main/assets/images/Images/Capacity Planning - Images/cp_graph_02.png";
import cp_graph03 from "../../../main/assets/images/Images/Capacity Planning - Images/cp_graph_03.png";
import cp_graph04 from "../../../main/assets/images/Images/Capacity Planning - Images/cp_graph_04.png";
type Props = {};

const Capacityplanning = (props: Props) => {
  interface CARDDATA {
    path: string;
    title: string;
    textmsg: string;
    whiteIcon?: string;
  }
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const [activetIndex, setActiveIndex] = useState(0);
  const goToSlide = (index: number) => {
    setActiveIndex(index);
  };
  const carddata: CARDDATA[] = [
    {
      path: maximizedresources,
      whiteIcon: Layer1,
      title: "Maximized Resource Utilization",
      textmsg:
        "Ensures resources are efficiently allocated to reduce delay and improve SLA.",
    },
    {
      path: costSavings,
      whiteIcon: costsavings2,
      title: "Cost Savings",
      textmsg:
        "Accurate forecast helps organizations reduce unnecessary expenses caused by over-staffing or underutilization of resources.",
    },
    {
      path: agileOperations,
      whiteIcon: agileOperations2,
      title: "Agile Operations",
      textmsg:
        "Help businesses adapt to changes in demand/supply quickly, thereby ensuring smooth and uninterrupted operations.",
    },
  ];
  return (
    <div>
      <PlatformModulesBanner
        graphImage={cp_graph01}
        backgroundImage={capacityplanningbanner}
        MobilebgImage={Mobilebanner}
        mobilepraphImage={cpgraph}
        descriptionClass="text-white-color fonts-400 font-20 mb-20 font-family-roboto"
        HeaderClassName="text-white-color fonts-300 font-40 mb-10 font-family-condensed plat-header"
        heading="Capacity Planning"
        description="Advanced forecasting using AI & ML"
        buttonGroup={
          <>
            <div className="d-block d-md-none">
              <Link to={"/contact-us"}>
                <Button
                  textclass="font-16 fonts-500 align-items-center text-center line-19 font-family-roboto-flex justify-content-center"
                  className="wx-90 hx-30 text-color-success radius-5 d-flex align-items-center text-align-center justify-content-center"
                  text="Book a Demo"
                />
              </Link>
            </div>
            <div className="d-none d-md-block">
              <Link to={"/contact-us"}>
                <Button
                  textclass="font-16 fonts-500 align-items-center text-center line-19 p-17 font-family-roboto-flex justify-content-center"
                  className="wx-147 hx-40 text-color-success radius-5 d-flex align-items-center text-align-center justify-content-center"
                  text="Book a Demo"
                />
              </Link>
            </div>
          </>
        }
      />
      <div>
        <div className="p-0">
          <HeadingParagrap
            heading=" Capacity Planning"
            headingpara="Create the forecasting trend using the power of AI & ML; and incorporating the power of external factors like weather, seasonality, and other parameters, ensuring your field services are always a step ahead in preparedness and response."
          />
        </div>
        {/* website */}
        <div className="py-60 bg-color-n d-none d-md-block justify-content-center align-items-center">
          <div className="d-flex text-white-color font-family-roboto font-30 flex-gap-20 fonts-800 line-35 pb-60 justify-content-center align-items-center garph-heading">
            Top Features
          </div>
          <div className="d-flex flex-column flex-gap-30 container justify-content-center align-items-center">
            <GraphDataOnLeft
              path={cp_graph02}
              headingClass="text-black-10"
              heading="Forecasting Dashboard"
              paragraph="Visualize trends, insights, and forecasts through a user-centric interface designed for quick decision-making."
            />
            <GraphDataOnRight
              path={cp_graph03}
              headingClass="text-black-10"
              heading="Leverage Multiple Algorithms"
              paragraph="Based on data and other external parameters Yantr.ai decides the best forecasting model to be imposed for calculating forecast values and provide more accurate results."
            />
            <GraphDataOnLeft
              path={cp_graph04}
              headingClass="text-black-10"
              heading="Demand and Supply Linkage"
              paragraph="Based on the forecast, Yantr.ai provides supply demand mapping; and helps business leaders to reduce supply-demand gaps."
            />
          </div>
        </div>
        {/*Mobile */}
        <div className="pb-30 bg-color-n d-block  d-md-none justify-content-center align-items-center">
          <div className="d-flex text-white-color font-family-roboto font-30 flex-gap-20 fonts-800 line-35 pt-40 pb-10 justify-content-center align-items-center garph-heading">
            Top Features
          </div>
          <div className="d-flex flex-column flex-gap-20 py-30 container graphcontainer justify-content-center align-items-center">
            <GraphDataOnLeft
              path={cp_graph1}
              headingClass="text-black-10"
              heading="Forecasting Dashboard"
              paragraph="Visualize trends, insights, and forecasts through a user-centric interface designed for quick decision-making."
            />
            <GraphDataOnRight
              path={cp_graph2}
              headingClass="text-black-10"
              heading="Leverage Multiple Algorithms"
              paragraph="Based on data and other external parameters Yantr.ai decides the best forecasting model to be imposed for calculating forecast values and provide more accurate results."
            />
            <GraphDataOnLeft
              path={cp_graph3}
              headingClass="text-black-10"
              heading="Demand and Supply Linkage"
              paragraph="Based on the forecast, Yantr.ai provides supply demand mapping; and helps business leaders to reduce supply-demand gaps."
            />
          </div>
        </div>
      </div>
      {/* mobile */}
      <div className="d-block d-md-none">
        <div className="container-fluid">
          <h2 className="dark-header font-30 font-family-roboto fonts-800 line-35 mt-4 d-flex justify-content-center align-items-center plat-header">
            Benefits
          </h2>
          <div className="row mx-1 mb-40 p-10">
            <Swiper
              slidesPerView={"auto"}
              spaceBetween={0}
              pagination={{
                clickable: true,
              }}
              modules={[Pagination]}
              className="mySwiper customSwiper"
            >
              {carddata.map((val, index) => (
                <SwiperSlide className="p10">
                  <div className="col-md-12 col-sm-12 col-lg-12 p-10">
                    <Col key={index}>
                      <SectionCardMobile
                        classname="cards"
                        title={val.title}
                        icon={val.path}
                        whiteIcon={val.whiteIcon}
                        desc={val.textmsg}
                      />
                    </Col>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </div>
      {/* website */}
      <div className="d-none d-md-block pt-60 pb-30">
        <div className="container">
          <h2 className="dark-header font-30 font-family-roboto fonts-800 line-35 mb-20 d-flex justify-content-center align-items-center plat-header">
            Benefits
          </h2>
          <div className="row mx-1 p-10">
            {carddata.map((item, index) => (
              <div className="col-md-6 col-sm-6 col-lg-4 p-10">
                <div
                  className={`scard-container d-flex flex-column py-20 radius-10 justify-content-center align-items-center border border-1`}
                  key={index}
                >
                  <div className="image-container">
                    <img
                      className="sfront-image mx-5 my-3 mt-4"
                      src={item?.path}
                      alt="background will be here"
                    />
                    <img
                      className="sback-image mx-5 mb-2"
                      src={item?.whiteIcon}
                      alt="background will be here"
                    />
                  </div>
                  <div className="card-body">
                    <p
                      className={`d-flex justify-content-center text-center card-title px-5 fonts-600 font-family-roboto font-26 line-30 pb-2`}
                      style={{ color: "#3D1187" }}
                    >
                      {item?.title}
                    </p>
                    <p
                      className="px-3 tcard-desc text-center text-white-color fonts-400 font-16 line-20 font-family-roboto"
                      style={{ color: "#3D1187" }}
                    >
                      {item?.textmsg}
                    </p>
                  </div>
                </div>
                <div className="d-block d-md-none text-center">
                  <button
                    key={index}
                    className={
                      index === activetIndex
                        ? "active p-1"
                        : "banner-slider p-1"
                    }
                    onClick={() => goToSlide(index)}
                  ></button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="">
        <PlatformLearnMore />
      </div>
    </div>
  );
};

export default Capacityplanning;
